/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValueDto } from './valueDto';
import { ImplementIdDto } from './implementIdDto';
import { GeometryIdDto } from './geometryIdDto';
import { AccountingDto } from './accountingDto';
import { WorkstateTimeDto } from './workstateTimeDto';
import { MainAccountingDto } from './mainAccountingDto';

export interface ImplementDataDto {
  accounting?: Array<AccountingDto>;
  duration?: number;
  durationFiredUp?: number;
  durationIdle?: number;
  durationWaiting?: number;
  durationWorked?: number;
  fuelConsumed?: number;
  geometry?: GeometryIdDto;
  ha?: number;
  implement?: ImplementIdDto;
  km?: number;
  kmWorked?: number;
  mainAccounting?: MainAccountingDto;
  mainAccountingFuel?: MainAccountingDto;
  mappingParameter?: Array<ValueDto>;
  startDate?: string;
  workstateTimes?: Array<WorkstateTimeDto>;
}
